import AHref from "../../../../components/ahref/ahref";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import { FontProps, FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";

interface Props  {
	label: string;
    url?: string;
    Font?: React.FC<FontProps>;
}

const ExternalLink: React.FC<Props> = ({ label, url, Font }) => {
    const FontComponent = Font || FontBody1;
    return url
            ?   <AHref href={url} target="_blank">
                    <FontComponent color={FONT_COLOR.ACCENT1} variant={FONT_VARIANT.UNDER_LINE}>
                        {label}
                    </FontComponent>
                </AHref>
            :   <FontComponent>{label}</FontComponent>
}

export default ExternalLink;